import { ModalHardwareInstall } from "../components/modal-hardware-install";
import { ContextModalHardwareInstallProvider } from "../context/modal-hardware-install-provider";
import { ModalHardwareInstallProps } from "../types/index";

export default function LayoutModalHardwareInstall(
  props: ModalHardwareInstallProps,
) {
  return (
    <>
      <ContextModalHardwareInstallProvider {...props}>
        <ModalHardwareInstall />
      </ContextModalHardwareInstallProvider>
    </>
  );
}
